import { BrowserUtils } from '@azure/msal-browser';

// MSAL renews tokens silently by loading the redirect URI - which is the SPA root - inside a hidden
// iframe. Booting the app in that frame makes MSAL throw block_iframe_reload/hash_empty_error and
// duplicates API calls and telemetry, so callers use this to skip any work in that frame.
// Kept in its own module so AppInsights can use it without importing the auth module (circular import).
export function isMsalHiddenIframe(): boolean {
    try {
        // Throws when the document is an iframe holding an authentication response, which is exactly MSAL's renewal frame.
        BrowserUtils.blockReloadInHiddenIframes();
        return false;
    } catch {
        return true;
    }
}
